<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import CustomLoader from "@/components/widgets/custom-loader";
import CustomFilter from "@/components/widgets/custom-filter";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Subject Analysis",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomFilter,
    CustomLoader,
  },
  data() {
    return {
      title: "View Subject Analysis",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "View Subject Analysis",
          active: true,
        },
      ],
      filterMarks: {
        class: "",
        term: "",
        year: "",
        stream: "",
        set: 0,
      },
    };
  },
  computed: {
    ...mapGetters("marks", [
      "SaveStatus",
      "getSubjectAnalysis",
      "getCurrentClass",
      "getYears",
    ]),
    ...mapGetters("classes", ["AllClassStreams", "AllClasses"]),
    ...mapGetters("coursework", ["AllSets"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions({
      FetchSetsMarksFilters: "marks/fetchSetsMarksFilters",
      FetchYears: "marks/fetchYear",
      FilterSubjectAnalysis: "marks/filterSubjectAnalysis",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchSets: "coursework/fetchSets",
    }),

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },

    filterSubjectAnalysis() {
      this.FilterSubjectAnalysis(this.filterMarks);
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('advanced_marks_reports')
        )
      "
    >
      <CustomFilter>
        <form @submit.prevent="filterSubjectAnalysis()">
          <div class="row">
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Year <small class="text-danger">*</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="filterMarks.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Term <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="filterMarks.term"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Term</option>
                  <option value="1">Term 1</option>
                  <option value="2">Term 2</option>
                  <option value="3">Term 3</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Class <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="filterMarks.class"
                  @change="fetchStreamsinClass($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Exam Set
                  <small class="text-primary">(Optional)</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="filterMarks.set"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Exam Set</option>
                  <option value="0">All Sets</option>
                  <option
                    v-for="(set, index) in AllSets"
                    :key="index"
                    :value="set.id"
                  >
                    {{ set.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Stream
                  <small class="text-primary">(Optional)</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="filterMarks.stream"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Stream</option>
                  <option
                    v-for="(stream, index) in AllClassStreams"
                    :value="stream.id"
                    :key="index"
                  >
                    {{ stream.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2 mt-4">
              <!-- <button
                type="submit"
                disabled
                class="btn btn-sm btn-outline-primary mt-1"
                v-if="SaveStatus"
              >
                <b-spinner
                  variant="primary"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Fetching Data...
              </button> -->
              <button
                type="submit"
                size="sm"
                class="btn btn-sm btn-outline-primary mt-1"
              >
                <i class="fa fa-check"></i>
                Submit Filers
              </button>
            </div>
          </div>
        </form>
      </CustomFilter>
      <CustomLoader v-if="SaveStatus"></CustomLoader>
      <div class="col-md-12" v-else>
        <div class="card" v-if="getSubjectAnalysis">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Divisions For Term {{ filterMarks.term }}
                  {{ filterMarks.year }}
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 mt-4 custom-vert">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">SUBJECT</th>
                          <th scope="col">D1</th>
                          <th scope="col">D2</th>
                          <th scope="col">C3</th>
                          <th scope="col">C4</th>
                          <th scope="col">C5</th>
                          <th scope="col">C6</th>
                          <th scope="col">P7</th>
                          <th scope="col">P8</th>
                          <th scope="col">F9</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(sub, subIndex) in getSubjectAnalysis"
                          :key="subIndex"
                        >
                          <td>{{ subIndex + 1 }}</td>
                          <td>{{ sub.subject }}</td>
                          <td>{{ sub.d1 }}</td>
                          <td>{{ sub.d2 }}</td>
                          <td>{{ sub.c3 }}</td>
                          <td>{{ sub.c4 }}</td>
                          <td>{{ sub.c5 }}</td>
                          <td>{{ sub.c6 }}</td>
                          <td>{{ sub.p7 }}</td>
                          <td>{{ sub.p8 }}</td>
                          <td>{{ sub.f9 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <strong>Please filter students using the above inputs.</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
